export default __webpack_public_path__ + "static/media/p4.7d5e5540.jpg";